export default __webpack_public_path__ + "img/86ee54799b7bbc5b9bd9a819855b11f3.png";